<template>
    <div>
        <div class="header">
            <div class="header_left">
                <img class="logo"  @click="skipHome" :src="require('@/assets/logo.png')" alt="" />
                <div class="header_list">
                    <div class="header_list_item" :class="selectTabIndex == item.path ? 'header_list_acitve' :''" v-for="(item,index) in tabList" :key="index" @click="tabClick(item,index)">{{item.label}}</div>
                </div>
            </div>
            <div class="header_right">
                <el-dropdown v-if="userInfo && userInfo.wxAccount">
                    <span class="el-dropdown-link login">
                        {{ userInfo && userInfo.wxAccount && userInfo.wxAccount.name
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="outLogin"
                                >退出</span
                            ></el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
                <span class="login" @click="login" v-if="!userInfo">登录</span>
                <div class="tel">
                    <div>189-5152-4007</div>
                    <div>全国统一热线</div>
                </div>
            </div>
        </div>
        <div class="header_placeholder"></div>
        <el-dialog title="微信扫码登录" :visible.sync="isVisible" width="350px">
            <div>
                <div class="qrcode">
                    <img :src="qrcodeUrl" alt="" />
                    <div>打开微信扫一扫，快速登录/注册</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getAreaSelect,
    getLoginPic,
    getTokenCheck,
    getInfo,
} from "@/api/home";
import { setToken, getToken, removeToken } from "@/utils/auth";
export default {
    name: "headers",
    data() {
        return {
            dialogVisible: false,
            qrcodeUrl: "",
            timer: null,
            uuid: null,
            userInfo: localStorage.getItem("userInfo")
                ? JSON.parse(localStorage.getItem("userInfo"))
                : null,
            searchVisible: false,
            orderDetail: null,
            tabList:[
                {
                    id:0,
                    path:'/',
                    label:'首页'
                },
                {
                    id:1,
                    path:'/product',
                    label:'服务产品'
                },
                {
                    id:2,
                    path:'/about',
                    label:'关于我们'
                }
            ],
            selectTabIndex:''
        };
    },
    created() {
        // console.log(this.userInfo);
        this.uuid = this.uuid2(16, 16);
        this.getQRcode();
        if (getToken()) {
            this.getInfoData();
            // console.log(this.userInfo);
        }else{
            localStorage.removeItem("userInfo");
            this.userInfo = null;
        }
        
    },
    mounted(){
        if(this.$router.history.current.fullPath){
            setTimeout(() => {
                this.selectTabIndex = this.$router.history.current.fullPath;
            },100)
            
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.dialogVisible;
            },
            set() {
                this.cancelDataScope();
            },
        },
    },
    methods: {
        skipHome() {
            this.$router.replace({
                path: "/",
            });
        },
        login() {
            this.uuid = this.uuid2(16, 16);
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.getQRcode();
                this.getTokenData();
            });
        },
        cancelDataScope() {
            this.dialogVisible = false;
            clearInterval(this.timer);
        },
        getQRcode() {
            getLoginPic({}, this.uuid).then((response) => {
                let url = URL.createObjectURL(response);
                this.qrcodeUrl = url;
            });
            // this.getTokenData();
        },
        getInfoData() {
            getInfo({}).then((response) => {
                // console.log(response);
                if (response.code == 200) {
                    this.userInfo = response.user;
                    localStorage.setItem(
                        "userInfo",
                        JSON.stringify(response.user)
                    );
                }
            });
        },
        outLogin() {
            removeToken();
            localStorage.removeItem("userInfo");
            window.location.reload();
        },
        getTokenData() {
            this.timer = setInterval(() => {
                getTokenCheck({}, this.uuid).then((response) => {
                    if (response.data) {
                        this.$message;
                        setToken(response.data);
                        clearInterval(this.timer);
                        this.dialogVisible = false;
                        this.getInfoData();
                    }
                });
            }, 1000);
        },
        uuid2(len, radix) {
            var chars =
                "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
                    ""
                );
            var uuid = [],
                i;
            radix = radix || chars.length;

            if (len) {
                // Compact form
                for (i = 0; i < len; i++)
                    uuid[i] = chars[0 | (Math.random() * radix)];
            } else {
                // rfc4122, version 4 form
                var r;

                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
                uuid[14] = "4";

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | (Math.random() * 16);
                        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
                    }
                }
            }

            return uuid.join("");
        },
        tabClick(item,index){
            this.selectTabIndex = item.path;
            this.$router.push({
                path: item.path
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.logo{
    width: 300px;
    height: 126px;
}
.header_placeholder{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
    height: 116px;
}
.header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 10px 20px;
    height: 163px;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    .header_left {
        display: flex;
        align-items: center;
        font-size: 22px;
        color: #333;
        cursor: pointer;
        img {
            width: 218px;
            height: 78px;
            margin-right: 200px;
        }
    }
    .header_right {
        display: flex;
        align-items: center;

        .login {
            font-size: 18px;
            font-weight: bold;
            color: #333;
            margin-right: 20px;
            cursor: pointer;
        }
        .tel {
            font-size: 18px;
            text-align: center;
            color: red;
        }
    }
}
.qrcode {
    text-align: center;
    img {
        width: 150px;
        height: 150px;
        margin-bottom: 10px;
    }
}
.el-dropdown-link {
    cursor: pointer;
    color: #409eff;
}
.el-icon-arrow-down {
    font-size: 12px;
}
.header_list{
    display: flex;
    width: 500px;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    color: #333;
}
.header_list_acitve{
    color: #295091 !important;
}
</style>